export const en = {
    'error-refresh': 'An error occurred. Try refreshing the page.',
    'success-cooperation-request':
        'Thank you for your request! Please wait until the expert contacts you or contact them using the details on this page'
};
